import { render, staticRenderFns } from "./DragDropImages.vue?vue&type=template&id=20377252&"
import script from "./DragDropImages.vue?vue&type=script&lang=js&"
export * from "./DragDropImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports